export default "__VITE_ASSET__n8BWbYnP__"